/**
 * Authentication service.
 * VULN: JWT tokens stored in localStorage — accessible to any JavaScript on the page (XSS).
 * A stored XSS attack (VULN-A-002) can steal tokens via localStorage.getItem('token').
 */
import axios from "axios";

const API_BASE = import.meta.env.VITE_API_BASE ?? "https://app.memesec-factory.com/api/v1";

export interface AuthUser {
  user_id: number;
  username: string;
  is_admin: boolean;
  access_token: string;
}

export const authService = {
  async register(username: string, email: string, password: string): Promise<AuthUser> {
    const { data } = await axios.post(`${API_BASE}/auth/register`, {
      username,
      email,
      password,
    });
    // VULN: Token stored in localStorage — survives XSS
    localStorage.setItem("token", data.access_token);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  },

  async login(username: string, password: string): Promise<AuthUser> {
    const { data } = await axios.post(`${API_BASE}/auth/login`, { username, password });
    // VULN: Token in localStorage
    localStorage.setItem("token", data.access_token);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  },

  logout(): void {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },

  getToken(): string | null {
    return localStorage.getItem("token");
  },

  getCurrentUser(): AuthUser | null {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  isAdmin(): boolean {
    return this.getCurrentUser()?.is_admin ?? false;
  },
};
